import React from 'react';

import { DeviceContext } from '@/components/DeviceProvider/DeviceProvider';
import { HederItemRoute } from '@/components/Header/types';
import { GameClickProps } from '@/components/modular-grid/types';
import { mapNavItems } from '@/components/Navigation/utils';
import { AccountLinkType, NavigationImageType } from '@/types/common';

import MainNavigation from './MainNavigation';
import { CardCategoryItem, NavigationCategoryItem } from './types';
interface SideNavigationPropTypes {
  onItemClick?: (args: {
    itemTitle?: string;
    path?: string;
    account?: AccountLinkType;
  }) => void;
  onNavigationGameClick?: (args: {
    itemTitle: string;
    game: GameClickProps;
    sectionTitle: string;
    gamePosition: number;
  }) => void;
  onNavigationGameInfoClick?: (args: {
    itemTitle: string;
    game: GameClickProps;
    sectionTitle: string;
    gamePosition: number;
  }) => void;
  onNavigationCommandClick?: (args: {
    itemTitle: string;
    account?: string;
  }) => void;
  categories: {
    title?: string;
    type: 'Navigation - Left' | 'Card';
    items: {
      title: string;
      state: 'active' | 'inactive';
      image: NavigationImageType;
      route_link: string;
      routes?: HederItemRoute;
    }[];
    hide_on?: string[];
  }[];
  currentPagePath: string;
  visible?: boolean;
}
const SideNavigation: React.FC<SideNavigationPropTypes> = ({
  onItemClick,
  onNavigationCommandClick,
  onNavigationGameClick,
  onNavigationGameInfoClick,
  categories,
  currentPagePath,
  visible,
}) => {
  const { deviceOs } = React.useContext(DeviceContext);
  const handleMenuItemClick = (
    event: React.MouseEvent<{}>,
    item: NavigationCategoryItem | CardCategoryItem
  ) => {
    const { route_link, command, title, tracking_metadata } = item;
    if (route_link || command) {
      event.preventDefault();
    }

    onItemClick &&
      onItemClick({
        itemTitle: tracking_metadata?.title || title,
        path: route_link,
        account: command,
      });
  };

  const navCategoryItems =
    categories &&
    categories.map(category => {
      return {
        ...category,
        items:
          category.items &&
          mapNavItems(category.items, [currentPagePath], { deviceOs }),
      };
    });

  return (
    <MainNavigation
      categories={navCategoryItems}
      onItemClick={handleMenuItemClick}
      onNavigationGameClick={onNavigationGameClick}
      onNavigationCommandClick={onNavigationCommandClick}
      onNavigationGameInfoClick={onNavigationGameInfoClick}
      onSubMenuItemClick={onItemClick}
      visible={visible}
    />
  );
};

export default SideNavigation;
